import api from '../../services/api';

/*
 * The whole kardex, as the Movimientos screen reads it. The same endpoint the
 * product kardex uses (`inventories/movements/`), without the product: every
 * SKU, narrowed by the filters of the screen. The server applies the scope.
 */

/**
 * A page of movements, newest first.
 *
 * @param {object} params - `warehouse, company, search (SKU or name),
 *   slot_search (location name or code), movement_type, actor (id or 'none'),
 *   date_from, date_to, page, page_size`.
 * @returns {Promise<{data: {count: number, results: Array<object>}}>}
 */
export const getMovementsRequest = async (params) => {
  return await api.get('inventories/movements/', { params });
};

/**
 * The options of the "quién" filter: whoever left a movement in reach, and
 * whether the system left any on its own.
 *
 * @param {object} params - `warehouse`
 * @returns {Promise<{data: {actors: Array<{id: number, email: string}>, has_system: boolean,
 *   movement_types: Array<{value: string, label: string}>}}>}
 */
export const getMovementsFiltersRequest = async (params) => {
  return await api.get('inventories/movements/filters/', { params });
};
